import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Button as AbroadButton } from '@abroad/components'

/**
 * Shared Experience v7 button.
 * Variants: primary (navy), outline, sm, danger, gold (crop / accent primary).
 * Uses Abroad Button under the hood for loading/disabled behaviour when needed.
 */
const ExperienceButton = ({
  variant = 'outline',
  size,
  className,
  type = 'button',
  children,
  isLoading,
  disabled,
  onClick,
  form,
  ...rest
}) => {
  const classes = classNames(
    {
      'btn-navy': variant === 'primary' || variant === 'navy',
      'btn-outline-experience': variant === 'outline',
      'btn-danger-experience': variant === 'danger',
      'btn-gold-experience': variant === 'gold',
      'experience-btn-sm': size === 'sm' || variant === 'sm',
      'btn-sm-experience': size === 'sm',
    },
    className,
  )

  if (isLoading !== undefined) {
    return (
      <AbroadButton
        type={type}
        variant='none'
        className={classes}
        isLoading={isLoading}
        disabled={disabled}
        onClick={onClick}
        form={form}
        {...rest}>
        {children}
      </AbroadButton>
    )
  }

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      form={form}
      {...rest}>
      {children}
    </button>
  )
}

ExperienceButton.propTypes = {
  variant: PropTypes.oneOf([
    'primary',
    'navy',
    'outline',
    'danger',
    'gold',
    'sm',
  ]),
  size: PropTypes.oneOf(['sm']),
  className: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  form: PropTypes.string,
}

export default ExperienceButton
